import React from "react";
import { motion } from "framer-motion";
import { Eyebrow } from "@/components/Eyebrow";

export function WhoRunsIt() {
    return (
        <section id="who-runs-it" data-testid="who-runs-it" className="py-20 sm:py-28">
            <div className="max-w-4xl mx-auto px-5 sm:px-8">
                <Eyebrow>Who runs it</Eyebrow>
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="mt-8 space-y-8"
                >
                    <p className="font-display font-semibold tracking-[-0.02em] text-2xl sm:text-4xl leading-[1.18]">
                        ReplAIced was built by an operator, not a consultant. Years spent physically
                        running departments, doing the manual work most automation tools claim to fix
                        but don't understand.
                    </p>
                    <p className="font-display font-semibold tracking-[-0.02em] text-2xl sm:text-4xl leading-[1.18] text-muted-foreground">
                        The proof the model works: this entire agency runs on it. One operator, no
                        engineering team, amplified by AI. That is not a pitch. It is the exact system
                        we install in your business.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
